/** Curated-SFX pilot: canonical PCM16 mono WAV only, <=2 seconds.
 * Not a permissive general audio upload decoder. */
export const MAX_SFX_BYTES = 192044;
export function readPcmSfx(bytes: ArrayBuffer): { sampleRate: number; samples: Float32Array } {
  if (bytes.byteLength < 46 || bytes.byteLength > MAX_SFX_BYTES) throw new Error('SFX byte limit');
  const view = new DataView(bytes);
  const tag = (at: number) => String.fromCharCode(...new Uint8Array(bytes, at, 4));
  const rate = view.getUint32(24, true), size = view.getUint32(40, true);
  if (tag(0) !== 'RIFF' || tag(8) !== 'WAVE' || tag(12) !== 'fmt ' || tag(36) !== 'data' ||
    view.getUint32(4, true) !== bytes.byteLength - 8 || view.getUint32(16, true) !== 16 ||
    view.getUint16(20, true) !== 1 || view.getUint16(22, true) !== 1 ||
    view.getUint16(34, true) !== 16 || view.getUint16(32, true) !== 2 ||
    rate < 8000 || rate > 48000 || view.getUint32(28, true) !== rate * 2 ||
    size !== bytes.byteLength - 44 || size % 2 || size / 2 > rate * 2) throw new Error('Unsupported SFX WAV format');
  const samples = new Float32Array(size / 2);
  for (let i = 0; i < samples.length; i++) {
    samples[i] = view.getInt16(44 + i * 2, true) / 32768;
    if (Math.abs(samples[i]!) > 0.95) throw new Error('SFX peak exceeds safe ingestion bound');
  }
  return { sampleRate: rate, samples };
}

/** Project-authored deterministic impact: integer math gives identical bytes
 * across engines. No provider, borrowed recording or randomness. */
export function curatedImpactWav(): ArrayBuffer {
  const count = 3840, rate = 24000;
  const bytes = new ArrayBuffer(44 + count * 2), view = new DataView(bytes);
  const tag = (at: number, value: string) => [...value].forEach((c, i) => view.setUint8(at + i, c.charCodeAt(0)));
  tag(0, 'RIFF'); view.setUint32(4, bytes.byteLength - 8, true); tag(8, 'WAVE'); tag(12, 'fmt ');
  view.setUint32(16, 16, true); view.setUint16(20, 1, true); view.setUint16(22, 1, true);
  view.setUint32(24, rate, true); view.setUint32(28, rate * 2, true); view.setUint16(32, 2, true); view.setUint16(34, 16, true);
  tag(36, 'data'); view.setUint32(40, count * 2, true);
  for (let i = 0; i < count; i++) {
    const triangle = Math.abs((i % 120) - 60) - 30;
    view.setInt16(44 + i * 2, Math.trunc(triangle * 220 * (count - i) / count), true);
  }
  return bytes;
}
